export const API_BASE_URL = "https://marketing-be.technogroves.com";
// export const API_BASE_URL = "http://localhost:8000";

export const backendUrl = API_BASE_URL;

export const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const clientId = localStorage.getItem("client_id") || "1";
  const storeId = localStorage.getItem("store_id") || "1";

  const headers = {
    "Content-Type": "application/json",
  };

  if (token && token !== "dummy-token-123456") {
    headers["Authorization"] = `Token ${token}`;
  }
  headers["X-Client-Id"] = clientId;
  headers["X-Store-Id"] = storeId;

  return headers;
};

export const apiFetch = async (endpoint, options = {}) => {
  const url = endpoint.startsWith("http") ? endpoint : `${API_BASE_URL}${endpoint}`;
  const headers = {
    ...getAuthHeaders(),
    ...options.headers,
  };

  const config = {
    ...options,
    headers,
  };

  const response = await fetch(url, config);

  if (response.status === 204) {
    return null;
  }

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    const errorMsg = (data && (data.detail || data.message || JSON.stringify(data))) || "API request failed";
    throw new Error(errorMsg);
  }

  return data;
};

export const apiGet = (endpoint, options = {}) => {
  return apiFetch(endpoint, { ...options, method: "GET" });
};

export const apiPost = (endpoint, body, options = {}) => {
  return apiFetch(endpoint, {
    ...options,
    method: "POST",
    body: body ? JSON.stringify(body) : undefined,
  });
};

export const apiPut = (endpoint, body, options = {}) => {
  return apiFetch(endpoint, {
    ...options,
    method: "PUT",
    body: body ? JSON.stringify(body) : undefined,
  });
};

export const apiPatch = (endpoint, body, options = {}) => {
  return apiFetch(endpoint, {
    ...options,
    method: "PATCH",
    body: body ? JSON.stringify(body) : undefined,
  });
};

export const apiDelete = (endpoint, options = {}) => {
  return apiFetch(endpoint, { ...options, method: "DELETE" });
};

export const apiUploadCsv = async (file, defaultAccept = true) => {
  const token = localStorage.getItem("token");
  const clientId = localStorage.getItem("client_id") || "1";
  const storeId = localStorage.getItem("store_id") || "1";

  const headers = {};
  if (token && token !== "dummy-token-123456") {
    headers["Authorization"] = `Token ${token}`;
  }
  headers["X-Client-Id"] = clientId;
  headers["X-Store-Id"] = storeId;

  const formData = new FormData();
  formData.append("file", file);

  const url = `${API_BASE_URL}/stores/contacts/uploadCsv?default_accept_email_marketing=${defaultAccept}`;
  const response = await fetch(url, {
    method: "POST",
    headers,
    body: formData,
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    const errorMsg = (data && (data.detail || data.message)) || "CSV upload failed";
    throw new Error(errorMsg);
  }

  return data;
};



// --- Expiration & Cookie Helpers ---

/**
 * Sets a cookie with a specific expiration in seconds
 */
export const setCookie = (name, value, seconds) => {
  const maxAge = seconds ? `; max-age=${seconds}` : "";
  document.cookie = `${name}=${value || ""}${maxAge}; path=/; Secure; SameSite=Strict`;
};

/**
 * Retrieves a cookie by name
 */
export const getCookie = (name) => {
  const nameEQ = name + "=";
  const cookiesArray = document.cookie.split(';');
  for (let i = 0; i < cookiesArray.length; i++) {
    let c = cookiesArray[i].trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Deletes a cookie by name
 */
export const eraseCookie = (name) => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

/**
 * Checks if the authentication credentials have expired.
 * Returns true if expired or missing, false otherwise.
 */
export const checkTokenExpiration = () => {
  const token = localStorage.getItem("token");
  const expiry = localStorage.getItem("token_expiry");
  const cookieToken = getCookie("token");
  const now = new Date().getTime();

  // Expired if:
  // 1. No token in localStorage
  // 2. Cookie is missing (cookie expired natively)
  // 3. Expiry timestamp has passed
  if (!token || !cookieToken || (expiry && now > parseInt(expiry))) {
    return true;
  }
  return false;
};

/**
 * Clears all authentication-related storage and cookies
 */
export const clearAuthData = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("token_expiry");
  localStorage.removeItem("username");
  localStorage.removeItem("user_type");
  localStorage.removeItem("client_id");
  localStorage.removeItem("store_id");
  localStorage.removeItem("emailApp_storeName");
  eraseCookie("token");
};
